import {
	BULK_DOWNLOAD_SUCCESS,
	BULK_DOWNLOAD_FAILURE,
	BULK_EXTERNAL_SEND_SUCCESS,
	BULK_EXTERNAL_SEND_FAILURE,
	CONVERT_TO_PDF_FAILURE,
	AUDIT_SEARCH_SUCCESS,
	AUDIT_SEARCH_FAILURE,
	INDEX_MISSING_SEARCH_ITEMS_SUCCESS,
	INDEX_MISSING_SEARCH_ITEMS_FAILURE,
	CLOSE_GLOBAL_EDIT_DIALOG,
	OPEN_GLOBAL_SNACKBAR,
	UNSELECT_ALL,
} from "./types";

import API from "../utilities/LocalApiProxy";
import { openGlobalDialog } from "./globalEditDialogActions";

const generalErrorMessage =
	"LexWorkplace Encountered an Error; Please Contact Support";

const bulkServerUnreachableMessage =
	"The Bulk Operations server could not be reached";

export function beginRenameJob(jobID, successCallback, failureCallback) {
	return function (dispatch) {
		beginLongJob(
			jobID,
			successCallback,
			failureCallback,
			"Renaming Folder...",
			"Renaming",
			"Folder Renamed"
		)(dispatch);
	};
}
export function beginDeleteJob({
	jobID,
	successCallback,
	failureCallback,
	action,
}) {
	// possible actions: DELETE, RESTORE_FROM_TRASH, ARCHIVE, RESTORE_FROM_ARCHIVE
	const [progressText, buttonText, completedText] = {
		DELETE: [
			"Moving Items to Trash Bin",
			"Move to Trash Bin",
			"Items Sent to Trash Bin",
		],
		RESTORE_FROM_TRASH: [
			"Restoring Items from Trash Bin",
			"Restore from Trash Bin",
			"Items Restored from Trash Bin",
		],
		ARCHIVE: ["Archiving Items", "Archive", "Items Archived"],
		RESTORE_FROM_ARCHIVE: [
			"Unarchiving Items",
			"Unarchive",
			"Items Unarchived",
		],
	}[action];
	return function (dispatch) {
		beginLongJob(
			jobID,
			successCallback,
			failureCallback,
			progressText,
			buttonText,
			completedText
		)(dispatch);
	};
}
export function beginCutPasteJob(jobID, successCallback, failureCallback) {
	return function (dispatch) {
		beginLongJob(
			jobID,
			successCallback,
			failureCallback,
			"Moving Items...",
			"Move",
			"Items Moved"
		)(dispatch);
	};
}
export function beginCopyPasteJob(jobID, successCallback, failureCallback) {
	return function (dispatch) {
		beginLongJob(
			jobID,
			successCallback,
			failureCallback,
			"Calculating Copy Operation...",
			"Copy",
			"Copy Operation Complete"
		)(dispatch);
	};
}
export function beginDuplicationJob(jobID, successCallback, failureCallback) {
	return function (dispatch) {
		beginLongJob(
			jobID,
			successCallback,
			failureCallback,
			"Duplicating Document...",
			"Duplicate",
			"Duplicate Operation Complete"
		)(dispatch);
	};
}
export function beginReindexJob(jobID, successCallback, failureCallback) {
	return function (dispatch) {
		beginLongJob(
			jobID,
			successCallback,
			failureCallback,
			"Generating manifest file for rebuilding search index...",
			"Copy",
			"Manifest file generated and uploaded.  Click refresh to see in-progress re-index job",
			getAdminJobProgress
		)(dispatch);
	};
}
export function beginBulkExternalSendJob(jobID, sharePassword, shareID) {
	return function (dispatch) {
		const tooManyItemsMessage =
			"The selected folders have too many files to download in a single ZIP file.  Please navigate to sub-folders as necessary to individually download folders with fewer items";

		const successCallback = (jobInfo) => {
			console.log(jobInfo);
			dispatch({
				type: BULK_EXTERNAL_SEND_SUCCESS,
				payload: {
					message: "Sent email with download link to recipients",
					sharePassword: sharePassword || null,
					shareID: shareID || null,
				},
			});
		};
		const failureCallback = (jobInfo) => {
			var jobData = JSON.parse(jobInfo.jobData);
			var message = generalErrorMessage;
			if (
				jobData.message &&
				jobData.message.error &&
				jobData.message.error.code
			) {
				if (jobData.message.error.code === 7002) {
					message =
						"Outgoing share could not be completed because the email could not be sent";
				}
			} else if (jobData.message === "BULK_SERVER_UNREACHABLE") {
				message =
					"Outgoing share failed:" + bulkServerUnreachableMessage;
			} else {
				if (jobData.message === "FAILED_TOO_MANY_FILES") {
					message = tooManyItemsMessage;
				}
			}

			dispatch({
				type: BULK_EXTERNAL_SEND_FAILURE,
				payload: { message },
			});
		};

		beginLongJob(
			jobID,
			successCallback,
			failureCallback,
			"Preparing selected files...",
			"File Send"
		)(dispatch);
	};
}
export function beginBulkDownloadJob(jobID, fullMatter) {
	return function (dispatch) {
		const tooManyItemsMessage = `${
			fullMatter ? "This matter has" : "The selected folders have"
		} too many files to download in a single ZIP file.  Please navigate to sub-folders as necessary to individually download folders with fewer items`;

		const successCallback = (jobInfo) => {
			var jobData = JSON.parse(jobInfo.jobData);
			window.location.href = jobData.signedUrlResult;
			dispatch({
				type: BULK_DOWNLOAD_SUCCESS,
				payload: {
					message: fullMatter
						? "Matter Export Complete - downloading ZIP..."
						: "Data Export Complete - downloading ZIP...",
				},
			});
		};
		const failureCallback = (jobInfo) => {
			var jobData = JSON.parse(jobInfo.jobData);
			var message = generalErrorMessage;
			if (jobData.message) {
				if (jobData.message === "FAILED_TOO_MANY_FILES") {
					message = tooManyItemsMessage;
				} else if (jobData.message === "BULK_SERVER_UNREACHABLE") {
					message =
						"Bulk Download Failed:" + bulkServerUnreachableMessage;
				}
			}
			dispatch({
				type: BULK_DOWNLOAD_FAILURE,
				payload: { message },
			});
		};

		beginLongJob(
			jobID,
			successCallback,
			failureCallback,
			"Generating ZIP File",
			fullMatter ? "Matter Export" : "Data Export"
		)(dispatch);
	};
}
function beginLongJob(
	jobID,
	successCallback,
	failureCallback,
	calculatingMessage,
	progressPrefix,
	successMessage,
	jobProgressFn = getJobProgress
) {
	return function (dispatch) {
		dispatch({
			type: "COPY_PASTE_STARTED",
			payload: { jobID },
		});
		dispatch({
			type: "OPEN_LOADING_SNACKBAR",
			payload: { message: calculatingMessage },
		});
		if (jobID) {
			var jobPoll = setInterval(() => {
				jobProgressFn(jobID).then((res) => {
					if (res.mysql[0].status === 2) {
						//success
						clearInterval(jobPoll);
						dispatch({
							type: "JOB_COMPLETE",
							payload: { id: jobID },
						});
						if (successMessage) {
							dispatch({
								type: "OPEN_GLOBAL_SNACKBAR",
								payload: {
									message: successMessage,
									variant: "success",
									loadingSpinnerVisible: false,
									allowClose: true,
								},
							});
						}
						successCallback && successCallback(res.mysql[0]);
					} else if (res.mysql[0].status === 1) {
						//still in progress
						if (res.mysql[0].type === "convertToPDF") {
							dispatch({
								type: "UPDATE_SNACKBAR_MESSAGE",
								payload: {
									message: `${progressPrefix} In Progress`,
								},
							});
						} else {
							dispatch({
								type: "UPDATE_SNACKBAR_MESSAGE",
								payload: {
									message: `${progressPrefix} ${res.mysql[0].percentDone}% Complete`,
								},
							});
						}
					} else if (res.mysql[0].status === 3) {
						//failure
						clearInterval(jobPoll);
						console.log("Job failed", jobID);
						failureCallback && failureCallback(res.mysql[0]);
					} else {
						//still calculating time, no need to update
					}
				});
			}, 4000);
		}
	};
}
export function testGetAllDocs() {
	return function (dispatch) {
		API.post("/worker/test").then((res) => {
			var jobID = res.mysql.jobID;
			beginCopyPasteJob(jobID)(dispatch);
		});
	};
}

function getJobProgress(jobID) {
	return API.post("/jobs", { body: { jobID } });
}

function getAdminJobProgress(jobID) {
	return API.post("/admin/jobs", { body: { jobID } });
}

// Polls an admin job (see /admin/jobs) to completion and resolves with the
// final job row, rejecting on failure. Used by flows (e.g. WipeTenantDialog)
// that need to await a job's outcome directly rather than drive a snackbar.
export function pollAdminJobToCompletion(jobID, onProgress) {
	return new Promise((resolve, reject) => {
		const jobPoll = setInterval(() => {
			getAdminJobProgress(jobID)
				.then((res) => {
					const job = res.mysql[0];
					if (job.status === 2) {
						clearInterval(jobPoll);
						resolve(job);
					} else if (job.status === 3) {
						clearInterval(jobPoll);
						reject(job);
					} else if (job.status === 1 && onProgress) {
						let jobData = null;
						try {
							jobData = job.jobData
								? JSON.parse(job.jobData)
								: null;
						} catch {
							jobData = null;
						}
						onProgress(job.percentDone, jobData);
					}
				})
				.catch((err) => {
					clearInterval(jobPoll);
					reject(err);
				});
		}, 4000);
	});
}
export function beginConvertToPDFJob(jobID, currentFileName, successCallback) {
	return function (dispatch) {
		const failureCallback = (jobInfo) => {
			var jobData = JSON.parse(jobInfo.jobData);

			const message =
				jobData &&
				jobData.message &&
				jobData.message === "BULK_SERVER_UNREACHABLE"
					? "Convert to PDF Failed:" + bulkServerUnreachableMessage
					: "Convert to PDF Failed:" + generalErrorMessage;
			dispatch({
				type: CONVERT_TO_PDF_FAILURE,
				payload: { message },
			});
		};

		beginLongJob(
			jobID,
			successCallback,
			failureCallback,
			`Converting ${currentFileName} to PDF...`,
			`Converting ${currentFileName} to PDF...`
		)(dispatch);
	};
}
export function beginAuditSearchIndexJob(jobID) {
	return function (dispatch) {
		const successCallback = (jobInfo) => {
			const { jobData, ...jobMetadata } = jobInfo;
			var auditData = JSON.parse(jobData);
			//console.log("audit Success", data);
			dispatch({
				type: AUDIT_SEARCH_SUCCESS,
				payload: {
					message: "Search Index Audit Complete",
					auditData,
					jobMetadata,
				},
			});
		};

		const failureCallback = (jobInfo) => {
			const { jobData, ...jobMetadata } = jobInfo;
			var auditData = JSON.parse(jobData);

			dispatch({
				type: AUDIT_SEARCH_FAILURE,
				payload: {
					message: "Search Index Audit Failed",
					auditData,
					jobMetadata,
				},
			});
		};

		beginLongJob(
			jobID,
			successCallback,
			failureCallback,
			"Auditing Search Index ...",
			"Comparing",
			undefined,
			getAdminJobProgress
		)(dispatch);
	};
}
export function beginAuditAndIndexMissingItemsJob(jobID) {
	return function (dispatch) {
		const successCallback = (jobInfo) => {
			const { jobData, ...jobMetadata } = jobInfo;
			var repairData = JSON.parse(jobData);
			//console.log("audit Success", data);
			dispatch({
				type: INDEX_MISSING_SEARCH_ITEMS_SUCCESS,
				payload: {
					message: `Indexing Missing Items has started.  Check the "Batch Jobs" tab for this firm to see progress`,
					repairData,
					jobMetadata,
				},
			});
		};

		const failureCallback = (jobInfo) => {
			const { jobData, ...jobMetadata } = jobInfo;
			var repairData = JSON.parse(jobData);

			dispatch({
				type: INDEX_MISSING_SEARCH_ITEMS_FAILURE,
				payload: {
					message: "Indexing Missing Items has failed to start",
					repairData,
					jobMetadata,
				},
			});
		};

		beginLongJob(
			jobID,
			successCallback,
			failureCallback,
			"Setting up Missing Items re-Index Job ...",
			"Comparing",
			undefined,
			getAdminJobProgress
		)(dispatch);
	};
}

function validatePermanentDeleteDialog(state) {
	// validate function
	if (state.permanentDeleteConfirmationObject.confirmed) {
		return { canSubmit: true };
	} else {
		return {
			canSubmit: false,
			disabledHoverTextForSubmitButton: !state
				.permanentDeleteConfirmationObject.confirmed
				? '"confirm" must be typed into the box above'
				: "",
		};
	}
}

export function handlePermanentDeleteFlow({
	jobID,
	objectIDs,
	trashPageContext,
}) {
	//WARNING: trashPageContext may or may not have a trailing slash/ depending on the caller

	// objectIDs = {
	// 	Folder: [],
	// 	File: [],
	// 	Email: [],
	// 	Note: [],
	// 	Matter: [],
	// 	Client: [],
	// }
	return function (dispatch, getState) {
		function submitPermanentDelete(state) {
			// submit function
			const permanentDeleteConfirmationObject =
				state.permanentDeleteConfirmationObject;

			if (permanentDeleteConfirmationObject) {
				const requestBody = {
					permanentDeleteGenerationJobID: jobID,
				};
				let currentTrashList = getState().trash.trashList;
				// filter out the IDs that were selected for permanent delete
				const filteredTrashList = currentTrashList.filter(
					(item) => !objectIDs[item.type]?.includes(item.id)
				);

				API.post("/trash/executePermanentDelete", {
					body: { ...requestBody },
				})
					.then(() => {
						/*
							This request invokes a function that will permanently delete
							the requested database records (document, matter, etc.)

							The response here is an acknowledgement that the job has started,
							but its possible that the actual records have not been removed yet
							so we can't simply refresh the page and expect to see the selected
							items gone.

							So we fake it here by hiding those items immediately from the view

						*/
						dispatch({
							type: "HIDE_ITEMS_PERM_DELETE_STARTED_WITH",
							payload: {
								trashList: filteredTrashList,
							},
						});
						dispatch({
							type: UNSELECT_ALL,
						});
						dispatch({
							type: OPEN_GLOBAL_SNACKBAR,
							payload: {
								variant: "success",
								message: `Successfully started permanent delete job. You can check the "Activity" tab in the Trash Bin to see progress.`,
							},
						});
					})
					.catch((err) => {
						console.error(err);
						dispatch({
							type: OPEN_GLOBAL_SNACKBAR,
							payload: {
								variant: "error",
								message:
									"We were not able to process your request. Please try again.",
							},
						});
					});
			} else {
				console.error("no permanentDeleteConfirmationObject");
				dispatch({
					type: OPEN_GLOBAL_SNACKBAR,
					payload: {
						variant: "error",
						message:
							"We were not able to process your request. Please try again.",
					},
				});
			}
			dispatch({
				type: CLOSE_GLOBAL_EDIT_DIALOG,
			});
		}
		// dispatch({
		// 	type: "COPY_PASTE_STARTED",
		// 	payload: { jobID },
		// });
		dispatch({
			type: "OPEN_REACT_DIALOG",
			payload: {
				showSpinnerInTitle: true,
				title: "Calculating...",
				mainContent:
					"Calculating items that will be permanently deleted...",
			},
		});
		if (jobID) {
			var jobPoll = setInterval(() => {
				getJobProgress(jobID).then((res) => {
					if (res.mysql[0].status === 2) {
						//success
						clearInterval(jobPoll);
						// dispatch({
						// 	type: "JOB_COMPLETE",
						// 	payload: { id: jobID },
						// });
						dispatch({
							type: "CLOSE_REACT_DIALOG",
							payload: {},
						});
						if (res.mysql[0].jobData) {
							var jobData = JSON.parse(res.mysql[0].jobData);

							openGlobalDialog(
								{
									label: `Permanently Delete Items`,
									canSubmit: false,
									disabledHoverTextForSubmitButton:
										'"confirm" must be typed into the box above',
									hideTextfield: true,
									type: "permanentDeleteConfirmationModal",
									submitButtonLabel: "Delete Forever",
									readOnly: false,
									extraCSSClass: "WideEditDialog",
									redSubmitButton: true,
									permanentDeleteConfirmationObject: {
										loading: false,
										trashPageContext,
										...jobData,
									},
								},
								(state) => submitPermanentDelete(state),
								(state) => validatePermanentDeleteDialog(state),
								() => {
									// cancel function
									dispatch({
										type: CLOSE_GLOBAL_EDIT_DIALOG,
									});
								}
							)(dispatch);
						}
					} else if (res.mysql[0].status === 1) {
						// I don't think I care about this
						//still in progress
						// if (res.mysql[0].type === "convertToPDF") {
						// 	dispatch({
						// 		type: "UPDATE_SNACKBAR_MESSAGE",
						// 		payload: {
						// 			message: `${progressPrefix} In Progress`,
						// 		},
						// 	});
						// } else {
						// 	dispatch({
						// 		type: "UPDATE_SNACKBAR_MESSAGE",
						// 		payload: {
						// 			message: `${progressPrefix} ${res.mysql[0].percentDone}% Complete`,
						// 		},
						// 	});
						// }
					} else if (res.mysql[0].status === 3) {
						//failure
						clearInterval(jobPoll);
						dispatch({
							type: "CLOSE_REACT_DIALOG",
							payload: {},
						});
						dispatch({
							type: "OPEN_GLOBAL_SNACKBAR",
							payload: {
								message: "Job Failed",
								variant: "error",
								loadingSpinnerVisible: false,
								allowClose: true,
							},
						});
						console.log("Job failed", jobID);
					} else {
						//still calculating time, no need to update
					}
				});
			}, 4000);
		}
	};
}
